// filtri/misure.ts — conti puri del motore (senza DOM), provati con node:test.

/** Converte i punti normalizzati di MediaPipe in pixel del fotogramma d'uscita (stessa disposizione x,y,z). */
export function inPixel(punti: readonly { x: number; y: number; z: number }[], w: number, h: number): Float64Array {
  const out = new Float64Array(punti.length * 3);
  for (let i = 0; i < punti.length; i++) {
    const p = punti[i]!;
    out[i * 3] = p.x * w;
    out[i * 3 + 1] = p.y * h;
    out[i * 3 + 2] = p.z * w; // MediaPipe: z nella stessa scala di x
  }
  return out;
}

/** Dimensioni del canvas: come il video, ma con il lato lungo al massimo `latoMassimo` (numeri pari per i codificatori). */
export function dimensioniUscita(larghezza: number, altezza: number, latoMassimo: number): { w: number; h: number } {
  const k = Math.min(1, latoMassimo / Math.max(larghezza, altezza, 1));
  const pari = (n: number) => Math.max(2, Math.round((n * k) / 2) * 2);
  return { w: pari(larghezza), h: pari(altezza) };
}
